import { Link } from 'react-router-dom';
import { ADDRESS_LINES, BOOKING_URL, BRAND, HOURS } from '@/constants';

const navLinks = [
  { label: 'Accueil', href: '#accueil' },
  { label: 'Le cabinet', href: '#a-propos' },
  { label: 'La thérapie', href: '#cupping' },
  { label: 'Bienfaits', href: '#bienfaits' },
  { label: 'Tarifs', href: '#tarifs' },
  { label: 'Avis', href: '#avis' },
  { label: 'Prise de RDV', href: BOOKING_URL },
];

export default function Footer() {
  const handleNav = (href: string) => {
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#04160f] pt-12 pb-8 px-6">
      <div className="max-w-[1180px] mx-auto">
        <div className="flex flex-wrap gap-10 justify-between items-start mb-12">
          <div className="max-w-xs">
            <img
              src={BRAND.logoUrl}
              alt={BRAND.name}
              className="h-[72px] w-auto object-contain mb-4"
            />
            <p className="text-[13.5px] leading-relaxed text-[#f7f3ea]/55 m-0">
              Cabinet de cupping thérapie à {BRAND.city}. Soins naturels pour soulager, récupérer et
              retrouver l&apos;équilibre.
            </p>
            <div className="flex gap-2.5 mt-5">
              {[
                {
                  icon: 'ri-instagram-line',
                  href: 'https://www.instagram.com/lifecupp.74',
                  label: 'Instagram @lifecupp.74',
                },
                {
                  icon: 'ri-tiktok-line',
                  href: 'https://www.tiktok.com/@lifecupp.74',
                  label: 'TikTok @lifecupp.74',
                },
                {
                  icon: 'ri-whatsapp-line',
                  href: `https://wa.me/${BRAND.phoneWhatsApp}`,
                  label: 'WhatsApp',
                },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener"
                  aria-label={s.label}
                  className="w-[38px] h-[38px] flex items-center justify-center border border-[#8fd6b8]/30 rounded-full text-[#8fd6b8] hover:bg-[#8fd6b8]/10 hover:text-[#c9ecd9] transition-colors"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex gap-16 flex-wrap">
            <div>
              <div className="text-[11px] font-bold tracking-[0.24em] uppercase text-[#f7f3ea]/45 mb-4">
                Navigation
              </div>
              <div className="flex flex-col gap-2.5">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      if (link.href.startsWith('#')) {
                        e.preventDefault();
                        handleNav(link.href);
                      }
                    }}
                    className="text-sm text-[#f7f3ea]/70 hover:text-[#8fd6b8] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <div className="text-[11px] font-bold tracking-[0.24em] uppercase text-[#f7f3ea]/45 mb-4">
                Contact
              </div>
              <div className="flex flex-col gap-2.5 text-sm text-[#f7f3ea]/70">
                <span>
                  <i className="ri-map-pin-line text-[#8fd6b8] mr-2"></i>
                  {ADDRESS_LINES.street}, {BRAND.city}
                </span>
                <span>
                  <i className="ri-phone-line text-[#8fd6b8] mr-2"></i>
                  {BRAND.phoneDisplay}
                </span>
                <span>
                  <i className="ri-mail-line text-[#8fd6b8] mr-2"></i>
                  {BRAND.email}
                </span>
                <span>
                  <i className="ri-time-line text-[#8fd6b8] mr-2"></i>
                  {HOURS.summary}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#8fd6b8]/15 pt-6 flex flex-wrap gap-3 justify-between items-center">
          <p className="text-xs text-[#f7f3ea]/40 m-0">
            © {new Date().getFullYear()} {BRAND.name}. Tous droits réservés.
          </p>
          <Link
            to="/politique-de-confidentialite"
            className="text-xs text-[#f7f3ea]/40 hover:text-[#8fd6b8] transition-colors"
          >
            Politique de confidentialité
          </Link>
        </div>
      </div>
    </footer>
  );
}
